export default __webpack_public_path__ + "static/pragicts-digital-outreach-verticals-cold-storage-c7d2b67835396d29f432c3a31eb9d345.jpg";